"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  rpc: {},
  types: {
    StorageValue: 'Vec<u8>',
    GraduallyUpdate: {
      key: 'StorageKey',
      targetValue: 'StorageValue',
      perBlock: 'StorageValue'
    },
    StorageKeyBytes: 'Vec<u8>',
    StorageValueBytes: 'Vec<u8>'
  }
};
exports.default = _default;